// extracted by mini-css-extract-plugin
export default {"Container":"planning_Container__nwABf","section-1":"planning_section-1__Z6iu-","content":"planning_content__EdWLH","section-2":"planning_section-2__A0c4s"};